import React, { forwardRef, useCallback } from "react";
import { InputLabel } from "./InputLabel";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

type Props = {
  label?: string;
  labelHint?: string;
  labelAdditionalContent?: JSX.Element;
  description?: string;
  onChange: (
    value: string,
    event: React.SyntheticEvent<HTMLInputElement>,
  ) => void;
  containerClassName?: string;
  validationError?: string | null;
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  "onChange"
>;

// @ts-ignore
export const Input: React.FC<Props> = forwardRef(
  ({ validationError, ...props }, ref) => {
    const handleChange = useCallback(
      (e: React.SyntheticEvent<HTMLInputElement>) => {
        props.onChange(e.currentTarget.value, e);
      },
      [props.onChange],
    );

    return (
      <div className={cn("flex flex-col", props.containerClassName)}>
        {(props.label || props.description) && (
          <InputLabel
            required={props.required}
            label={props.label}
            labelHint={props.labelHint}
            labelAdditionalContent={props.labelAdditionalContent}
            description={props.description}
          />
        )}
        <input
          ref={ref}
          {...props}
          value={props.value}
          style={{
            ...(props.style ?? {}),
            borderColor: validationError != null ? "red" : undefined,
          }}
          onChange={handleChange}
          className={twMerge(
            cn(
              "form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-clip-padding rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:outline-none disabled:opacity-50 dark:bg-neutral-800 dark:text-white dark:focus:bg-neutral-800 dark:focus:text-white dark:border-gray-500",
              {
                "border-gray-300 focus:border-blue-600":
                  validationError == null || validationError == "",
                "border-red-500": validationError != null,
              },
              props.className,
            ),
          )}
        />
      </div>
    );
  },
);
